import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { content } from "../../../data";
import MobileHeader from "./MobileHeader";
import useNetwork from "../../../Hooks/useNetwork";
import NftCartHub from "../../Modals/NftCartHub/NftCartHub";
import StyledSmText from "../../../common/components/styledSmText/StyledSmText";
import StyledLgText from "../../../common/components/styledLgText/StyledLgText";
import { CustomConnectButton } from "../../CustomConnectButton/CustomConnectButton";
import IconifyIcon from "../../icons/Icon";
import { useAccount } from "wagmi";
import { useGetCartNft } from "../../../Hooks/api/useGetCartList";

const Header = () => {
  const location = useLocation();

  const is404Page = location.pathname === "/404";
  const { isConnected, validChain } = useNetwork();
  const [showNftCartHub, setShowNftCartHub] = useState(false);
  const { address: walletAddress } = useAccount();

  const handleIconClick = () => {
    setShowNftCartHub(true);

  };
  const {data: cartData } = useGetCartNft(walletAddress && walletAddress);
  return (
    <header
      className={`w-full flex justify-center ${
        is404Page ? "bg-[#000]" : "!bg-transparent"
      }`}
    >
      <div className="w-[90%] sm:w-[85%] md:w-[80%] flex justify-between items-center yellow-border mt-5 py-3 px-4 z-50 bg-black">
        {/* LOGO */}
        <div className="max-w-[70%]">
          <Link to="/" aria-label="Home">
            <picture>
              <source
                media="(min-width: 640px)"
                srcSet="/assets/header-logo.svg"
              />
              <img
                src="/assets/mobile-header-logo.svg"
                alt="Logo"
                className="w-16 sm:w-auto"
              />
             
            </picture>
          </Link>
        </div>
        {/* NavLinks */}
        <nav className="hidden lg:flex gap-6 w-fit">
          {content.header.map((item, index) => (
            <NavLink
              key={index}
              to={item.link}
              className={`${
                location.pathname === item.link
                  ? "text-bright-yellow"
                  : "text-white"
              } hover:scale-x-110 hover:text-bright-yellow transform transition py-2 font-cp-bold`}
            >
              <StyledLgText className="cursor-pointer">{item.title}</StyledLgText>
            </NavLink>
          ))}
        </nav>
        {/* User Actions */}
        <div className="hidden lg:flex gap-2 items-center">
          <CustomConnectButton />
          {isConnected && validChain && (
            <>
              {/* User Profile */}
              <Link
                to="/profile"
                className="group relative cursor-pointer hover:bg-white hover:bg-opacity-10 border border-bright-yellow p-[10px] rounded-md"
                aria-label="User Profile"
              >
                <IconifyIcon
                  className="text-white group-hover:hidden cursor-pointer"
                  height={20}
                  width={20}
                  icon="fa-regular:user"
                  color="white"
                />

                <IconifyIcon
                  className="text-white group-hover:text-[#FFDE04] hidden group-hover:block cursor-pointer"
                  height={20}
                  width={20}
                  icon="fa-solid:user"
                  color="#FFDE04"
                />
              </Link>

              {/* User Cart Button */}
              <button
                className="relative group cursor-pointer hover:bg-white hover:bg-opacity-10 border border-bright-yellow p-[8px] rounded-md"
                onClick={handleIconClick}
                aria-label="User Cart"
              >
                <IconifyIcon
                  className="text-white group-hover:hidden cursor-pointer"
                  height={24}
                  width={24}
                  icon="mingcute:shopping-bag-2-line"
                  color="white"
                />

                <IconifyIcon
                  className="text-white group-hover:text-[#FFDE04] hidden group-hover:block cursor-pointer"
                  height={24}
                  width={24}
                  icon="mingcute:shopping-bag-2-fill"
                  color="#FFDE04"
                />

                {cartData?.length > 0 && (
                  <StyledSmText fontColor="absolute cursor-pointer -top-2 -right-2 !font-semibold w-5 h-5 text-black bg-bright-yellow rounded-full flex justify-center items-center">
                    {cartData?.length}
                  </StyledSmText>
                )}
              </button>
            </>
          )}
        </div>
        <MobileHeader cartData={cartData} />
      </div>
      {showNftCartHub && cartData !== undefined && (
        <NftCartHub
          closeModal={() => setShowNftCartHub(false)}
        />
      )}
    </header>
  );
};

export default Header;
